import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";
import { getDayOfWeek } from "@/v2/utils/date";
import {
    WorkingHourMapperParameter,
    WorkingHourFactory,
} from "@/v2/models/warehouse-working-hours.js";

export class Warehouse extends DataObject {
    _type = "warehouse";

    id;
    name;
    post_title;
    post_name;
    code;
    location_code;
    location_type;
    show_at_checkout;
    working_hour_from;
    working_hour_to;
    latitude;
    longitude;
    address;
    address2;
    phone_number;
    email;
    country;
    state;
    city;
    zip_code;
    full_address;
    vacation;
    delay_in_hour;
    note;
    company_id;
    company_name;
    created_at;
    updated_at;
    deleted_at;
    working_hours;

    isOffDay(date) {
        // return this.vacation.includes(getDayOfWeek(date));
        const daysArray = Object.values(this.working_hours).map(wh => wh.day);
        if(!daysArray.length) return false;

        const dayMap = {
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
            sunday: 7,
        };
        const numericDay = dayMap[getDayOfWeek(date)];

        return !daysArray.includes(numericDay);
    }

    isWorkingHours(date) {
        const time = date.getHours() * 60 + date.getMinutes();
        const start =
            this.working_hour_from.getHours() * 60 +
            this.working_hour_from.getMinutes();
        const end =
            this.working_hour_to.getHours() * 60 +
            this.working_hour_to.getMinutes();
        return time >= start && time <= end;
    }
}

export class WarehouseMapperParameter extends Parameter {
    warehouseMapper;
    workingHourMapperParameter = new WorkingHourMapperParameter();
}

export class WarehouseFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {WarehouseMapperParameter} warehouseMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the Warehouse object with.
     * @returns {Warehouse}
     */
    static construct(warehouseMapperParameter, data = null) {
        if (data != null) {
            let warehouse = DataObjectFactory.getInstance().construct(
                Warehouse,
                data ? warehouseMapperParameter.warehouseMapper(data) : null
            );

            if(warehouse.working_hours){
                const working_hours = {};
                data.working_hours.forEach((workingHour) => {
                    working_hours[workingHour.day] = WorkingHourFactory.construct(warehouseMapperParameter.workingHourMapperParameter, workingHour);
                });
                warehouse.working_hours = working_hours;
            }

            return warehouse;
        }

        return null;
    }
}
